import { render, staticRenderFns } from "./TeacherProfileForm.vue?vue&type=template&id=72b27972"
import script from "./TeacherProfileForm.vue?vue&type=script&lang=js"
export * from "./TeacherProfileForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports